import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';

const ErrorHandling = props => {

  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }

  const getcolor = () => {
    if (props.color && props.color != "")
      return props.color;
    else
      return "error";
  }

  const getintialtext = () => {
    if (props.color && props.color == "info")
      return "Info";
    else
      return "Error";
  }

  return (
    <div>
      <Snackbar open={props.open} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} onClose={() => { props.handleclose() }}>
        <Alert style={{ fontSize: '15px' }} onClose={() => { props.handleclose() }} color={getcolor()}>          {getintialtext()} : {props.msg}
        </Alert>
      </Snackbar>
    </div >
  );
};

export default ErrorHandling;
